import { render, staticRenderFns } from "./FalhaRetornos.vue?vue&type=template&id=058a27f1"
import script from "./FalhaRetornos.vue?vue&type=script&lang=js"
export * from "./FalhaRetornos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports